import script from "./AiView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiView.vue?vue&type=script&setup=true&lang=ts"

import "./AiView.vue?vue&type=style&index=0&id=2ad50448&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad50448"]])

export default __exports__